export default "__VITE_ASSET__8bcae4b0__"